import { styled } from 'styled-components';
import { SLi, SPMenu } from '~/pages/components/styles/styles';
import { classic } from '~/themes';

type IProps = {
  hidden?: boolean;
};

export function Rules({ hidden }: IProps) {
  return (
    <Container hidden={hidden}>
      <Wrapper>
        <SPMenu fontWeight="700">
          Bienvenue dans votre serious game dédié à la présentation des sites
          IDEEV et HENRI MOISSAN de l'Université Paris Saclay.
        </SPMenu>
        <br />
        <SPMenu>Pour vous repérer :</SPMenu>
        <SUl>
          <SLi>Choisissez votre site : IDEEV ou HENRI MOISSAN</SLi>
          <SLi>Choisissez une thématique</SLi>
          <SLi>
            Suivez les interactions avec le personnage en tapant sur l’écran
          </SLi>
          <SLi>
            Répondez aux questions, en vous aidant des indications affichées
          </SLi>
          <SLi>
            Les bonnes réponses que vous avez choisies seront affichées en{' '}
            <SSpan color={classic.token?.colorSuccess}>vert</SSpan> , celles que
            vous avez oubliées en{' '}
            <SSpan color={classic.token?.colorWarning}>orange</SSpan> et les
            mauvaises en <SSpan color={classic.token?.colorError}>rouge</SSpan>.
          </SLi>
          <SLi>
            Vous pouvez revenir à ce menu à tout moment, en cliquant en haut à
            gauche
          </SLi>
          <SLi>
            Vous pouvez fermer l’application à tout moment, en cliquant en haut
            à gauche
          </SLi>
        </SUl>

        <SPMenu>Bonne visite !</SPMenu>
      </Wrapper>
      <SDivBlur></SDivBlur>
    </Container>
  );
}

const Container = styled.div<{ hidden?: boolean }>`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  height: ${({ hidden }) => (hidden ? '0' : '100%')};
  opacity: ${({ hidden }) => (hidden ? '0' : '1')};
  padding: 0 30px 00px 30px;
  transition: all 0.3s 1s linear;
  position: relative;
  overflow-y: auto;
  width: 100%;
`;

const SDivBlur = styled.div`
  bottom: 0;
  background-image: linear-gradient(to bottom, rgba(0, 159, 195, 0), #009fc3);
  left: 0;
  height: 45px;
  position: absolute;
  width: 100%;
`;

const Wrapper = styled.div`
  height: 100%;
  overflow-y: auto;
  width: 100%;
  padding-bottom: 35px;
`;

const SUl = styled.ul`
  padding: 20px;
`;

const SSpan = styled.span<{ color?: string }>`
  border-radius: 4px;
  color: ${({ color }) => (color ? color : `${classic.token?.colorWhite}`)};
  font-weight: bold;
  background-color: white;
  padding: 0 5px;
`;
